export enum EButtonType {
  NoStyle = "NoStyle",
  Gallery = "Gallery",
  ListItem = "ListItem",
  ListItemDesktop = "ListItemDesktop",
  BasicLink = "BasicLink",
  BlueLink = "BlueLink",
  RedLink = "RedLink",
  WhiteLink = "WhiteLink",
  ProfileListed = "ProfileListed",
  ProfileListedError = "ProfileListedError",
  GreenWide = "GreenWide",
  BlueWide = "BlueWide",
  RedWide = "RedWide",
  WideGhost = "WideGhost",
  BluePill = "BluePill",
  GreenPill = "GreenPill",
  GhostPill = "GhostPill",
  BlackGhost = "BlackGhost",
  MenuItem = "MenuItem",
  ChatItem = "ChatItem",
  HeaderMenuOption = "HeaderMenuOption",
  MobileFilter = "MobileFilter",
  DesktopFilter = "DesktopFilter",
  ImageGalleryDot = "ImageGalleryDot",
  CompleteProfile = "CompleteProfile",
  Icon = "Icon",
  IconWithBackground = "IconWithBackground",
  InstagramImage = "InstagramImage",
  SwitchButton = "SwitchButton",
  TabButton = "TabButton",
  GhostWide = "GhostWide",
  RedWideOutline = "RedWideOutline",
  SocialLogin = "SocialLogin",
}

export enum EButtonActionType {
  InternalLink = "Internal Link",
  ExternalLink = "External Link",
  NormalButton = "Normal Button",
}
